let translations = {
  "General:Page": "Page",
  "General:OfTotal": "of {0}",
  "Framework:TotalFound": "Total {0} item(s) found",
  "Framework:Show": "Show",
  "Framework.TableSelectionHint:AllPageRowsSelected":
    "All {0} rows on this page has been selected.",
  "Framework.TableSelectionHint:SelectAllInTable": "Select all {0} items in this table.",
  "Framework.TableSelectionHint:AllTableRowsSelected":
    "All {0} rows on this table has been selected.",
  "Framework.TableSelectionHint:UndoTheSelection": "Undo the selection.",
  "General:Between": "Between",
  "General:AndLowerCase": "and",
  "Framework.DateFilter:LastXDay": "Last {0} days",
}

export default (key) => {
  return translations[key] || key
}
